import { AddToFavorites } from '@bygghemmait/components';

export default AddToFavorites;
